import { Deps, EffectCleanup, useEffect } from "@lukekaalim/act";
import { Subscription } from "rxjs";

export const createJanitor = (): Janitor => {
  const cleanups: EffectCleanup[] = [];

  return {
    add(cleanup: EffectCleanup | Subscription) {
      if (cleanup instanceof Subscription) {
        cleanups.push(() => cleanup.unsubscribe())
        return;
      }
      cleanups.push(cleanup);
    },
    cleanup() {
      for (const cleanup of cleanups) {
        try { cleanup() } catch (error) {
          console.warn(error);
        }
      }
    }
  }
};
export type Janitor = {
  add(cleanup: EffectCleanup | Subscription): void,
  cleanup(): void
}

/**
 * Like a normal useEffect function, but you get passed a janitor
 * in the arguments, and must assign cleanup tasks to the janitor instead
 * of returning them.
 * 
 * @param effectFunc
 * @param deps 
 */
export const useJanitorEffect = (effectFunc: (janitor: Janitor) => void, deps: Deps = null) => {
  useEffect(() => {
    const janitor = createJanitor();
    effectFunc(janitor);
    return janitor.cleanup;
  }, deps)
}
export const useJeffect = useJanitorEffect;